import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import ScrollBackward from '#components/svg/icons/ScrollBackward'
import ScrollForward from '#components/svg/icons/ScrollForward'
import i18n from 'i18next'

export const DEFAULT_TAKE = 20

function Pagination(props) {
  const take = props.take && props.take > 0 ? props.take : DEFAULT_TAKE
  const className = props.className ? props.className : 'dark'
  const {scrollCallback, data} = props
  const itemCount = data ? data.length : 0
  const [skip, setSkip] = useState(0)

  useEffect(() => {
    setSkip(0)
    scrollCallback(0, take)
  }, [])

  const dataString = JSON.stringify(data) // we need to use a string because array will always be a new instance and we might have an endless loop here
  useEffect(() => {
    setSkip(0)
    scrollCallback(0, take)
  }, [dataString])

  useEffect(() => {
    setSkip(0)
    scrollCallback(0, take)
  }, [take])

  if (take === 0 || itemCount <= take) {
    return null
  }

  const page = index => {
    return Math.floor(index / take) + 1
  }

  const forwardEnabled = () => {
    return skip + take < itemCount
  }

  const forward = () => {
    if (forwardEnabled()) {
      scroll(skip + take)
    }
  }

  const backwardEnabled = () => {
    return skip - take >= 0
  }

  const backward = () => {
    if (backwardEnabled()) {
      scroll(skip - take)
    }
  }

  const scroll = nextSkip => {
    setSkip(nextSkip)
    scrollCallback(nextSkip, take)
  }

  return (
    <div className={`pagination ${className}`}>
      <button data-testid="scroll-backward" disabled={!backwardEnabled()} onClick={backward}>
        <ScrollBackward disabled={!backwardEnabled()} light={className === 'light'} />
      </button>
      <span>{i18n.t('pagination_seite_von', [page(skip), page(itemCount - 1)])}</span>
      <button data-testid="scroll-forward" disabled={!forwardEnabled()} onClick={forward}>
        <ScrollForward disabled={!forwardEnabled()} light={className === 'light'} />
      </button>
    </div>
  )
}

Comment.propTypes = {
  data: PropTypes.array.isRequired,
  take: PropTypes.number,
  scrollCallback: PropTypes.func.isRequired,
  className: PropTypes.string,
}

export default Pagination
